import { IRegionOptionsGroup } from '../../../../components/LocationModal/mobile';
import { DEFAULT_REGIONS_CONFIG_KEY } from '../../../../constants/config';
import { useApplicationContext } from '../../../../utils/applicationContext';

export const useDefaultOptionGroups = (): IRegionOptionsGroup[] => {
  const { config } = useApplicationContext();

  return config.get<IRegionOptionsGroup[]>(DEFAULT_REGIONS_CONFIG_KEY) || [];
};
